import { render, staticRenderFns } from "./Electronics.vue?vue&type=template&id=683ca83a&scoped=true"
import script from "./Electronics.vue?vue&type=script&lang=js"
export * from "./Electronics.vue?vue&type=script&lang=js"
import style0 from "./Electronics.vue?vue&type=style&index=0&id=683ca83a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683ca83a",
  null
  
)

export default component.exports